import create from 'zustand'

interface TransferAgreementState {
	selectTransferAgreementModalOpened: boolean
	setSelectTransferAgreementModalOpened: (
		selectTransferAgreementModalOpened: boolean,
	) => void
	transferAgreement: {
		transferAgreementId: string
		photographerName: string
	} | null
	setTransferAgreement: (transferAgreement: {
		transferAgreementId: string
		photographerName: string
	}) => void
}

export const useTransferAgreementStore = create<TransferAgreementState>(
	(set) => ({
		selectTransferAgreementModalOpened: false,
		setSelectTransferAgreementModalOpened: (
			selectTransferAgreementModalOpened: boolean,
		) => {
			set({ selectTransferAgreementModalOpened })
		},
		transferAgreement: null,
		setTransferAgreement: (transferAgreement: {
			transferAgreementId: string
			photographerName: string
		}) => {
			set({ transferAgreement })
		},
	}),
)
